import { render, staticRenderFns } from "./BotaoAcaoTooltip.vue?vue&type=template&id=2b5e419e&scoped=true"
import script from "./BotaoAcaoTooltip.vue?vue&type=script&lang=js"
export * from "./BotaoAcaoTooltip.vue?vue&type=script&lang=js"
import style0 from "./BotaoAcaoTooltip.vue?vue&type=style&index=0&id=2b5e419e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e419e",
  null
  
)

export default component.exports